import { useEffect } from 'react';

import { useUserManager } from 'Shared/User/Hooks/useUserManager';

function SignOutPage() {
  const { clearUser } = useUserManager();

  useEffect(() => {
    clearUser();
  });

  return <></>;
}

export default SignOutPage;
